import { render, staticRenderFns } from "./Institutions.vue?vue&type=template&id=50f09fb1&scoped=true"
import script from "./Institutions.vue?vue&type=script&lang=js"
export * from "./Institutions.vue?vue&type=script&lang=js"
import style0 from "./Institutions.vue?vue&type=style&index=0&id=50f09fb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f09fb1",
  null
  
)

export default component.exports